import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Sobre from "./components/Sobre";
import MissaoVisaoValores from "./components/MissaoVisaoValores";
import AreasAtuacao from "./components/AreasAtuacao";
import Diferenciais from "./components/Diferenciais";
import CTA from "./components/CTA";
import Contato from "./components/Contato";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="font-sans">
      <Navbar />
      <Hero />
      <Sobre />
      <MissaoVisaoValores />
      <AreasAtuacao />
      <Diferenciais />
      <CTA />
      <Contato />
      <Footer />
    </main>
  );
}
